import { SelectOption } from '@navstation-portal/shared/data-model/common';
import { StateField, StateFieldType } from '../report.state';

export interface CargoState {
  [key: string]: StateFieldType;
  blCode: string;
  blDischarge: Date | undefined;
  blIssue: Date | undefined;
  blQuantity: number;
  cargoGrade: SelectOption;
  charterer: string;
  consignee: string;
  density: number;
  destinationPort: string;
  flashPoint: number;
  loadRate: number;
  loadTemp: number;
  pourPoint: number;
  s2sShipName: string;
  shipper: string;
  surveyorsCargoQuantity: number;
}

export interface TermainlState {
  name: string;
}

export interface StowageDetailsState {
  numberOfCargoes: number;
  cargoes: CargoState[];
}

export interface OtherDetailsCargoState {
  hoseDiameter: number;
  protestsReceived: SelectOption;
  protestsIssued: SelectOption;
  seaTemperature: number;
  airTemperature: number;
  protestsReceivedComments: string;
  protestsIssuedComments: string;
}

export const HoseType = {
  On: 'on',
  Off: 'off',
  Heating: 'heating',
} as const;

export type HoseType = (typeof HoseType)[keyof typeof HoseType];

export interface HoseOperationState {
  operationTimestamp: Date | undefined;
  ifo: number;
  lsf: number;
  lsg: number;
  mgoOn: number;
}

export interface HoseHeatingOperationState {
  comment: string;
  ifo: number;
  mgo: number;
}

export interface HosesState {
  operationType: SelectOption;
  terminal: string;
  description: SelectOption;
  hosesOn: HoseOperationState[];
  hosesOff: HoseOperationState[];
  heating: HoseHeatingOperationState[];
}

export interface CargoDetailsState {
  terminal: TermainlState;
  stowageDetails: StowageDetailsState;
  otherDetails: OtherDetailsCargoState;
  hoses: HosesState;
}

export interface CargoFormState {
  [key: string]: StateField<StateFieldType>;
  blCode: StateField<string | undefined>;
  blDischarge: StateField<Date | undefined>;
  blIssue: StateField<Date | undefined>;
  blQuantity: StateField<number | undefined>;
  cargoGrade: StateField<SelectOption | undefined>;
  charterer: StateField<string | undefined>;
  consignee: StateField<string | undefined>;
  density: StateField<number | undefined>;
  destinationPort: StateField<string | undefined>;
  flashPoint: StateField<number | undefined>;
  loadRate: StateField<number | undefined>;
  loadTemp: StateField<number | undefined>;
  pourPoint: StateField<number | undefined>;
  s2sShipName: StateField<string | undefined>;
  shipper: StateField<string | undefined>;
  surveyorsCargoQuantity: StateField<number | undefined>;
}

export interface HoseOperationFormState {
  [key: string]: StateField<StateFieldType>;
  operationTimestamp: StateField<Date | undefined>;
  ifo: StateField<number | undefined>;
  lsf: StateField<number | undefined>;
  lsg: StateField<number | undefined>;
  mgoOn: StateField<number | undefined>;
}

export interface HoseHeatingOperationFormState {
  [key: string]: StateField<StateFieldType>;
  comment: StateField<string | undefined>;
  ifo: StateField<number | undefined>;
  mgo: StateField<number | undefined>;
}
